import React from "react";
import '../css/contact.css';


function Contact() {

    return (

        <section id='Contact'>
             <div className="container contact__container">
                <h1>Contact</h1>

                <h2>Get in touch</h2>
                <p className="text_nofont">
                    IMPORTANT NOTE: We don't do walk ins, please book first before coming in. If you have any inquires please contact us via messages
                    or through our social media.</p>

                <div className="contact__content">

                    <div className="map">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d304.07473250061906!2d172.5326677859957!3d-43.52605614193895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d31f5131cad7061%3A0xb0d3a59a576551ff!2s8%20Mull%20Place%2C%20Broomfield%2C%20Christchurch%208042!5e0!3m2!1sen!2snz!4v1700991412445!5m2!1sen!2snz" 
                        style={{border:"0"}}
                       
                        title="locationMap"
                        loading="lazy" 
                        >
                        </iframe>
                    </div>
                    
                    <div className="inquire" >

                            <h2>Send us a message</h2>
                          
                            <div className="label__grid">
                                
                                 
                                    <input type="text" placeholder="First Name*" />
                              
                                    <input type="text" placeholder="Last Name*"  />
                              
                               
                            </div>
                            
                            <div className="label__grid">
                            
                                    
                                    <input type="text" id="name" name="name" placeholder="Email*" />
                             
                             
                                  
                                    <input type="number" id="name" name="name" placeholder="Phone*"/>
                                
                            </div>

                            
                                <textarea id="message" name="message" rows={4} cols={50} placeholder="Message*"/>
                            

                            <div className="submit__btn">
                                <button className="btn submit__btn">Submit</button>
                                <p className="text_nofont">*This form is not used for booking please <a href="/booking">click here </a>to make an Appointment</p>
                            </div>
                      
                    </div>
                </div>
             </div>

        </section>
       

    );

}

export default Contact;